import styled from "styled-components";
import { deviceType } from "@tm/isomorphic-utils";

export const InnerContentWrap = styled.div`
  width: 1200px;
  margin: 0 auto;
  @media screen and ${deviceType.mobile} {
    width: 100%;
  }
`;
